<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <b-card>
                    <div slot="header">
                        <i :class="[isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']"></i><strong> Afdeling</strong>
                        <small>
                            <span v-if="isEditing">wijzigen</span>
                            <span v-else>toevoegen</span>
                        </small>
                    </div>
                    <form @submit.prevent="saveItem">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label" for="naam">Naam <sup>*</sup></label>
                                <input type="text" v-model="model.naam" id="naam" name="naam" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('naam') }" />
                                <span class="small text-danger" v-show="errors.has('naam')">Naam is verplicht</span>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label" for="bedrijf">Bedrijf <sup>*</sup></label>
                                <select type="text" v-model="model.bedrijf_id" id="bedrijf" name="bedrijf" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('bedrijf') }" >
                                    <template v-for="bedrijf in bedrijven">
                                        <option :value="bedrijf.id" :selected="bedrijf.id == (model.bedrijf && model.bedrijf_id)">{{bedrijf.naam}}</option>
                                    </template>
                                </select>
                                <span class="small text-danger" v-show="errors.has('bedrijf')">Kies een bedrijf</span>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label" for="glastype">Glastype <sup>*</sup></label>
                                <select type="text" v-model="model.glastype_id" id="glastype" name="glastype" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('glastype') }" >
                                    <template v-for="glastype in glastypes">
                                        <option :value="glastype.id" :selected="glastype.id == (model.glastype && model.glastype_id)">{{glastype.omschrijving}}</option>
                                    </template>
                                </select>
                                <span class="small text-danger" v-show="errors.has('glastype')">Kies een glastype</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="col-form-label" for="oppervlakte">Oppervlakte <sup>*</sup> <span class="small">(m<sup>2</sup>)</span></label>
                                        <input type="number" v-model="model.oppervlakte" id="oppervlakte" name="oppervlakte" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('oppervlakte') }" />
                                        <span class="small text-danger" v-show="errors.has('oppervlakte')">Oppervlakte is verplicht</span>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="col-form-label" for="oppervlakte">Breedtegraad <sup>*</sup> <span class="small">(graden en minuten)</span></label>
                                        <table><tr><td>
                                        <input type="number" v-model="model.gr" id="gr" name="gr" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('gr') }" />
                                            </td><td>&nbsp;graden&nbsp;</td><td>
                                            <input type="number" v-model="model.cgr" id="cgr" name="cgr" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('cgr') }" />
                                            </td><td>&nbsp;minuten</td></tr></table>
                                        <span class="small text-danger" v-show="errors.has('gr') || errors.has('cgr')">Graden en minuten zijn verplicht</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="col-form-label" for="orientatie">Oriëntatie <span class="small">(graden)</span></label>
                                        <input type="number" step="1" min="0" max="999" v-model="model.orientatie" id="orientatie" name="orientatie" v-validate="'min_value:0|max_value:180'" :class="{'form-control': true, 'is-invalid': errors.has('orientatie') }" />
                                        <span class="small text-danger" v-show="errors.has('orientatie')">Oriëntatie is een waarde tussen 0 en 180</span>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="col-form-label" for="transmissiecoefficient">Transmissiecoëfficiënt <sup>*</sup> <span class="small">(percentage)</span></label>
                                        <input type="number" step=".01" min="0" max="999.99" v-model="model.transmissiecoefficient" id="transmissiecoefficient" name="transmissiecoefficient" v-validate="'required|min_value:0|max_value:100'" :class="{'form-control': true, 'is-invalid': errors.has('transmissiecoefficient') }" />
                                        <span class="small text-danger" v-show="errors.has('transmissiecoefficient')">Transmissiecoëfficiënt is een waarde tussen 0 en 100</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="col-form-label" for="poothoogte">Poothoogte <span class="small">(m)</span></label>
                                        <input type="number" step=".01" min="0" max="99.99" v-model="model.poothoogte" id="poothoogte" name="poothoogte" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="col-form-label" for="spantbreedte">Spantbreedte <span class="small">(m)</span></label>
                                        <input type="number" step=".01" min="0" max="99.99" v-model="model.spantbreedte" id="spantbreedte" name="spantbreedte" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label class="col-form-label" for="vakmaat">Vakmaat <span class="small">(m)</span></label>
                                        <input type="number" step=".01" min="0" max="99.99" v-model="model.vakmaat" id="vakmaat" name="vakmaat" class="form-control" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer">
                        <b-button type="submit" variant="primary">
                            <span>Opslaan</span>
                        </b-button>
                        <b-button type="button" @click="back" variant="secondary">Annuleren</b-button>
                        <b-button type="button" variant="outline-primary" @click="addBelichting">Belichting toevoegen</b-button>
                    </div>
                    </form>
                </b-card>
            </div>
        </div>
        <div class="row" v-for="(belichtings, indexi) in processedBelichting">
            <div class="col-lg-6" v-for="(belichting, indexj) in belichtings">
                <b-card
                        v-bind:data="belichting"
                        v-bind:key="belichting.id">
                    <div slot="header">
                        <i class='fa fa-align-justify'></i><strong> Belichting</strong>
                    </div>
                    <form @submit.prevent="saveBelichting">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label class="col-form-label" :for="'naamb' + (indexi * 2) + indexj">Naam <sup>*</sup></label>
                                    <input type="text" v-model="belichting.naam" :id="'naamb' + (indexi * 2) + indexj" name="naamb" :data-vv-name="'naam' + (indexi * 2) + indexj" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('naam' + (indexi * 2) + indexj) }" />
                                    <span class="small text-danger" v-show="errors.has('naam' + (indexi * 2) + indexj)">Naam is verplicht</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label class="col-form-label" :for="'soortbelichting' + (indexi * 2) + indexj">Soort belichting <sup>*</sup></label>
                                    <select type="text" v-model="belichting.soortbelichting_id" :id="'soortbelichting' + (indexi * 2) + indexj" name="soortbelichting" :data-vv-name="'soort' + (indexi * 2) + indexj" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('soort' + (indexi * 2) + indexj) }" >
                                        <template v-for="soortbelichting in soortbelichtingen">
                                            <option :value="soortbelichting.id" :selected="soortbelichting.id == (model.soortbelichting && model.soortbelichting_id)">{{soortbelichting.naam}}</option>
                                        </template>
                                    </select>
                                    <span class="small text-danger" v-show="errors.has('soort' + (indexi * 2) + indexj)">Kies een soort belichting</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" :for="'efficientie' + (indexi * 2) + indexj">Efficientie <sup>*</sup> <span class="small">(&#181;mol/J)</span></label>
                                    <input type="number" @change="berekenFlux(indexi,indexj)" step=".001" min="0" max="99.999" v-model="belichting.efficientie" :id="'efficientie' + (indexi * 2) + indexj" name="efficientie" :data-vv-name="'effi' + (indexi * 2) + indexj" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('effi' + (indexi * 2) + indexj) }" />
                                    <span class="small text-danger" v-show="errors.has('effi' + (indexi * 2) + indexj)">Efficientie is verplicht</span>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" :for="'aantalLampen' + (indexi * 2) + indexj">Aantal lampen <sup>*</sup></label>
                                    <input type="number" @change="berekenFlux(indexi,indexj)" min="0" v-model="belichting.aantalLampen" :id="'aantalLampen' + (indexi * 2) + indexj" name="aantalLampen" :data-vv-name="'aant' + (indexi * 2) + indexj" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('aant' + (indexi * 2) + indexj) }" />
                                    <span class="small text-danger" v-show="errors.has('aant' + (indexi * 2) + indexj)">Aantal lampen is verplicht</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" :for="'opgenomenVermogenPerLamp' + (indexi * 2) + indexj">Opgenomen vermogen/lamp <span class="small">(W) <sup>*</sup></span></label>
                                    <input type="number" @change="berekenFlux(indexi,indexj)" v-model="belichting.opgenomenVermogenPerLamp" :id="'opgenomenVermogenPerLamp' + (indexi * 2) + indexj" name="opgenomenVermogenPerLamp" :data-vv-name="'vermogen' + (indexi * 2) + indexj" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('vermogen' + (indexi * 2) + indexj) }"  />
                                    <span class="small text-danger" v-show="errors.has('vermogen' + (indexi * 2) + indexj)">Opgenomen vermogen/lamp is verplicht</span>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" :for="'fotonflux' + (indexi * 2) + indexj">Fotonflux <span class="small">(&#181;mol/s)<sup>*</sup></span></label>
                                    <input type="number" v-model="belichting.fotonflux" :id="'fotonflux' + (indexi * 2) + indexj" name="fotonflux" :data-vv-name="'fotonflux' + (indexi * 2) + indexj" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('fotonflux' + (indexi * 2) + indexj) }" />
                                    <span class="small text-danger" v-show="errors.has('fotonflux' + (indexi * 2) + indexj)">Fotonflux is verplicht</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" :for="'reflectorRendement' + (indexi * 2) + indexj">Reflectorrendement <span class="small">(percentage)</span></label>
                                    <input type="number" step=".1" min="0" max="999.9" v-model="belichting.reflectorRendement" :id="'reflectorRendement' + (indexi * 2) + indexj" name="reflectorRendement" :data-vv-name="'reflectorRendement' + (indexi * 2) + indexj" v-validate="'max_value:100'" :class="{'form-control': true, 'is-invalid': errors.has('reflectorRendement' + (indexi * 2) + indexj) }" />
                                    <span class="small text-danger" v-show="errors.has('reflectorRendement' + (indexi * 2) + indexj)">Reflectorrendement is maximum 100</span>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="col-form-label" :for="'warmteconvectie' + (indexi * 2) + indexj">Warmteconvectie <span class="small">(joule)</span></label>
                                    <input type="number" step=".01" min="0" max="9999.99" v-model="belichting.warmteconvectie" :id="'warmteconvectie' + (indexi * 2) + indexj" name="warmteconvectie" class="form-control" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <label class="col-form-label">Schakelniveaus</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <table>
                                    <tr>
                                        <template v-for="(schakelniveau, index2) in belichting.schakelniveau_n">
                                            <td>
                                                <input :disabled="! belichting.deleteok" style="width: 5em" type="number" min="0" max="100" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" v-model="schakelniveau.percentage" name="niveau" :data-vv-name="'niveau' + ((indexi * 2) + indexj)" v-validate="'required'" :class="{'form-control': true, 'is-invalid': (errors.has('niveau' + ((indexi * 2) + indexj)) || (totbel((indexi * 2) + indexj) !== 100)) }" />
                                            </td>
                                        </template>
                                        <td>
                                            <b-button v-show="(belichting.schakelniveau_n.length != 1) && belichting.deleteok" @click="verwijderSchakelniveau((indexi * 2) + indexj)" variant="primary"><i class='fa fa-minus-circle'></i></b-button>
                                            <b-button v-show="(belichting.schakelniveau_n.length != 5) && belichting.deleteok" @click="voegtoeSchakelniveau((indexi * 2) + indexj)" variant="primary"><i class='fa fa-plus-circle'></i></b-button>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <small>
                                        <label :class="{'text-danger': totbel((indexi * 2) + indexj) !== 100 }" class="col-form-label">Totaal schakelniveaus</label>
                                        <label :class="{'text-danger': totbel((indexi * 2) + indexj) !== 100 }">{{totbel((indexi * 2) + indexj)}} %</label>
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div slot="footer" align="right">
                            <b-button v-show="belichting.deleteok" @click="verwijderBelichting((indexi * 2) + indexj)" variant="primary"><i class='fa fa-trash'></i></b-button>
                        </div>
                    </form>
                </b-card>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <b-card>
                    <b-button @click="saveItem" variant="primary">
                        <span>Opslaan</span>
                    </b-button>
                    <b-button type="button" @click="back" variant="secondary">Annuleren</b-button>
                    <b-button type="button" variant="outline-primary" @click="addBelichting">Belichting toevoegen</b-button>
                </b-card>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'Form',
        props: ['model', 'bedrijven', 'glastypes', 'soortbelichtingen', 'isEditing'],
        methods: {
            komma0 (waarde) {
                if (isNaN(waarde)) {
                    return '#';
                }
                return waarde.toFixed(0);
            },
            berekenFlux (i, j) {
                // alert('hallo');
                // const belichting = this.processedBelichting[i][j];
                const belichting = this.model.belichting_n[(i * 2) + j];
                if ((belichting.efficientie) &&
                    (belichting.aantalLampen) &&
                    (belichting.opgenomenVermogenPerLamp) &&
                    (this.model.oppervlakte)) {
                    this.model.belichting_n[(i * 2) + j].fotonflux =
                        this.komma0((belichting.efficientie *
                        belichting.aantalLampen *
                        belichting.opgenomenVermogenPerLamp) / (this.model.oppervlakte));
                    // truukje omdat hij anders de gewijzigde gegevens niet ziet in computed functie
                    this.model.belichting_n.push({});
                    this.model.belichting_n.pop();
                }
            },
            isError () {
                let fout = false;
                for (let i = 0; i < this.model.belichting_n.length; i += 1) {
                    if (this.totbel(i) !== 100) {
                        fout = true;
                    }
                }
                return fout;
            },
            saveItem () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (!this.isError()) {
                            this.$emit('save-item', this.model);
                        }
                    }
                });
            },
            addBelichting () {
                this.model.belichting_n.unshift({ id: -1,
                    afdeling_id: this.model.id,
                    soortbelichting_id: this.soortbelichtingen[0].id,
                    deleteok: true,
                    schakelniveau_n: [{ id: -1, belichting_id: -1, percentage: 100 }] });
            },
            verwijderBelichting (i) {
                this.model.belichting_n.splice(i, 1);
            },
            voegtoeSchakelniveau (j) {
                this.model.belichting_n[j].schakelniveau_n.push(
                    { id: -1,
                        belichting_id: this.model.belichting_n[j].id });
            },
            verwijderSchakelniveau (j) {
                this.model.belichting_n[j].schakelniveau_n.pop();
            },
            totbel (j) {
                let result = 0;
                const belichting = this.model.belichting_n[j];
                if (typeof belichting !== 'undefined') {
                    for (let i = 0; i < belichting.schakelniveau_n.length; i += 1) {
                        if ((!belichting.schakelniveau_n[i].percentage) ||
                            (belichting.schakelniveau_n[i].percentage !== '')) {
                            result += (parseInt(
                                belichting.schakelniveau_n[i].percentage, 10) || 0);
                        }
                    }
                }
                return result;
            },
            back () {
                this.$router.go(-1);
            },
        },
        computed: {
            processedBelichting () {
                const belichtingen = this.model.belichting_n;
                if (typeof belichtingen !== 'undefined') {
                    // Put Array into Chunks
                    const chunkedArray = [];
                    const chunk = 2;
                    for (let i = 0, j = 0; i < belichtingen.length; i += chunk, j += 1) {
                        chunkedArray[j] = belichtingen.slice(i, i + chunk);
                    }
                    return chunkedArray;
                }
                return [];
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/afdeling/Form.vue